export enum Roles {
    CORP_BUYER = 'CORP_BUYER',
    CATEGORY_MANAGER = 'CATEGORY_MANAGER',
    CORP_SUPPORT = 'CORP_SUPPORT',
    CLERICAL = 'CLERICAL',
    IS_SUPPORT = 'IS_SUPPORT',
    EMER_BUSINESS = 'EMER_BUSINESS',
    CQA = 'CQA',
}
